import type * as React from "react";

import BrianMarkArt from "./brian-mark.svg?react";
import { cn } from "../lib/cn";

export type BrianMarkState =
  | "idle"
  | "listening"
  | "thinking"
  | "speaking"
  | "asking";

export type BrianMarkSize = 26 | 40;

// Animation spec pending.
const stateChrome: Record<BrianMarkState, string> = {
  idle: "border-transparent shadow-none",
  listening: "border-transparent shadow-halo-listening",
  thinking: "border-transparent shadow-halo-thinking",
  speaking: "border-accent shadow-halo-listening",
  asking: "border-transparent shadow-halo-asking",
};

const stateWord: Record<BrianMarkState, string> = {
  idle: "Brian",
  listening: "Brian, listening",
  thinking: "Brian, thinking",
  speaking: "Brian, speaking",
  asking: "Brian is asking",
};

export interface BrianMarkProps extends Omit<
  React.HTMLAttributes<HTMLSpanElement>,
  "children"
> {
  state?: BrianMarkState;
  size?: BrianMarkSize;
  label?: string;
  ref?: React.Ref<HTMLSpanElement>;
}

export function BrianMark({
  state = "idle",
  size = 40,
  label,
  className,
  ...rest
}: BrianMarkProps) {
  return (
    <span
      role="img"
      aria-label={label ?? stateWord[state]}
      data-state={state}
      {...rest}
      className={cn(
        "inline-flex shrink-0 rounded-full border-[1.5px] bg-sheet p-[5px] text-ink",
        stateChrome[state],
        className,
      )}
    >
      <BrianMarkArt
        width={size}
        height={size}
        aria-hidden="true"
        focusable="false"
        className="block"
      />
    </span>
  );
}
